import styles from "./myaccount.style.module.css";
import React, {useState, useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import ServerRequest from "../../ServerRequests/ServerRequest";
import LoaderPopup from "../../components/LoaderPopup/Loader";
import UnsubPopup from "../../components/UnsubPopup/UnsubPopup";

const MyAccount = () => {
  const navigate = useNavigate();

  const redirectToBack = () => {
    navigate(-1);
  };

  const [isUnsubPopupShown, setIsUnsubPopupShown] = useState(false);
  const [unsubMessageText, setUnsubMessageText] =
    useState({
      statusUnsubscription: false,
      textUnsubscription: ''
    });
  const [isLoading, setIsLoading] = useState(false);
  const loaderPopupRef = useRef(null);
  const [number, setNumber] = useState(localStorage.getItem("userPhone") || "+971 xxx-xxx-xxx");


  const handleUnsubscribe = async () => {
    const userIp = JSON.parse(sessionStorage.getItem("userIp"));
    setIsLoading(true);

    const serverData = await ServerRequest.unsubscribeUser(number, userIp);
    const parsedServerData = await serverData.json();
    console.log(parsedServerData);

    if (parsedServerData.status === 200) {
      setIsLoading(false);
      setIsUnsubPopupShown(true);
      setUnsubMessageText(
        {
          'statusUnsubscription': true,
          'textUnsubscription': `Twoja subskrypcja AI Dente została anulowana. Pamiętaj, że możesz nadal korzystać z usługi w trakcie opłaconego okresu subskrypcji.`
        })
    } else {
      setIsLoading(false);
      setIsUnsubPopupShown(true);
      setUnsubMessageText(
        {
          'statusUnsubscription': false,
          'textUnsubscription': `Coś poszło nie tak, spróbuj ponownie`
        })
    }
  }


  useEffect(() => {
    if (isLoading) {
      loaderPopupRef.current.showLoader();
      document.body.style.overflow = "hidden";
    } else {
      loaderPopupRef.current.hideLoader();
      document.body.style.overflow = "visible";
    }
  }, [isLoading]);


  return (
    <div className={styles.accountPage}>
      <span className={styles.accountPageTitle}>Tutaj możesz zarządzać swoją subskrypcją</span>
      <p className={styles.accountPageText}>
        Numer telefonu: <span>{number}</span>
      </p>
      <p className={styles.accountPageText}>
        Twoja subskrypcja AI Dente jest obecnie aktywna
      </p>

      <button className={styles.accountPageButton}
              onClick={handleUnsubscribe}>
        Anuluj subskrypcję
      </button>

      <p className={styles.lastTextAccount}>
        Nasza obsługa klienta jest również do Twojej dyspozycji!
      </p>
      <p className={styles.lastTextAccount}>
        Email: cc.pl@propulse.website
      </p>
      <a className={`${styles.lastTextAccount} ${styles.redirectMainPage}`} onClick={redirectToBack}>
        Powrót
      </a>
      {isUnsubPopupShown && <UnsubPopup handleShow={setIsUnsubPopupShown}
                                        isShown={isUnsubPopupShown}
                                        messageOptions={unsubMessageText}
      />}
      <LoaderPopup ref={loaderPopupRef}/>
    </div>
  );
};

export default MyAccount;
